import Tool, { simpleToolButton, type IToolAvailableInput } from './Tool';
import { isMindMap, isMindMapLeaf } from '../objects/guards';
import { enableLeafTheme } from './enableLeafTheme';

class ToolResetTheme extends Tool {
  static toolName = 'Reset theme';

  static action({ selection }) {
    enableLeafTheme(selection, true);
  }

  static available({ selection }: IToolAvailableInput) {
    const objects = selection?.getObjects() ?? [];
    for (const obj of objects) {
      if ((isMindMapLeaf(obj) || isMindMap(obj)) && !obj.useTheme) {
        return true;
      }
    }
    return false;
  }

  static buttonComponent() {
    return simpleToolButton(ToolResetTheme, 'fa-regular fa-rotate-left');
  }
}

export default ToolResetTheme;
